export class FormResponseTransformer {

    static transform(obj) {
        let response = {};
        response.id = obj.id;
        response.form_id = obj.attributes.form_id;
        response.form_criteria_id = obj.attributes.form_criteria_id;
        response.option_id = obj.attributes.option_id;
        response.value = obj.attributes.value;
        response.text = obj.attributes.text;
        return response;
    }

    static transformArray(array = []) {
        let data = [];
        array.map(function (item) {
            data.push(FormResponseTransformer.transform(item));
        });
        return data;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/forms/form-response.transformer.js